export default {
  name: 'dual-pre-control',
  path: 'dual-pre-control',
  component: () => import('@/views/container/Redirect.vue'),
  meta: {
    title: '双重预防机制',
    redirect: true,
    hideSubMenu: true,
    icon: 'icon-a-zu4676'
  },
  children: [

    {
      name: 'prevent-comprehensive-board',
      path: 'prevent-comprehensive-board',
      component: () => import('@/views/dual-pre-control/integrated-board/IntegratedBoard.vue'),
      meta: { title: '综合看板' }
    },
    {
      name: 'hierarchical-control',
      path: 'hierarchical-control',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '风险分级管控',
        redirect: true,
        icon: 'icon-fork'
      },
      children: [
        //   {
        //   name: 'risk-level',
        //   path: 'risk-level',
        //   component: () => import('@/views/dual-pre-control/hierarchical-control/risk-level/Index.vue'),
        //   redirect: {
        //     name: 'risk-level-List'
        //   },
        //   meta: {
        //     title: '风险辨识'
        //   },
        //   children: [{
        //     name: 'risk-level-List',
        //     path: '',
        //     component: () => import('@/views/dual-pre-control/hierarchical-control/risk-level/list/List.vue'),
        //     meta: {
        //       title: '风险辨识'
        //     },
        //   }, {
        //     name: 'risk-level-init',
        //     path: 'risk-level-init',
        //     component: () => import(
        //       '@/views/dual-pre-control/hierarchical-control/risk-level/components/Init.vue'),
        //     meta: {
        //       title: '风险辨识',
        //       redirect: true
        //     },
        //   }, {
        //     name: 'risk-level-edit',
        //     path: 'risk-level-edit',
        //     component: () => import('@/views/dual-pre-control/hierarchical-control/risk-level/list/Edit.vue'),
        //     meta: {
        //       title: '风险辨识'
        //     },
        //   }]
        // },
        {
          name: 'risk-level',
          path: 'risk-level',
          component: () => import(
            '@/views/dual-pre-control/hierarchical-control/risk-discrimination/RiskDiscrimination.vue'),
          meta: {
            title: '风险辨识'
          }
        },
        {
          name: 'risk-recognize',
          path: 'risk-recognize',
          component: () => import(
            '@/views/dual-pre-control/hierarchical-control/risk-assessment/RiskAssessment.vue'),
          meta: {
            title: '风险评价'
          }
        }

      ]
    },

    {
      name: 'hazar-investigation',
      path: 'hazar-investigation',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '隐患排查治理',
        redirect: true,
        icon: 'icon-fengxianpaicha'
      },
      children: [
        {
          name: 'investigation-task',
          path: 'investigation-task',
          component: () => import('@/views/dual-pre-control/hierarchical-control/hazar-investigation/investigation-task/index.vue'),
          meta: { title: '排查任务' }
        },
        {
          name: 'troubleshooting-records',
          path: 'troubleshooting-records',
          component: () => import('@/views/dual-pre-control/hierarchical-control/hazar-investigation/troubleshooting-records/TroubleshootingRecords.vue'),
          meta: { title: '排查记录' }
        },
        {
          name: 'hd-special-check',
          path: 'hd-special-check',
          component: () => import('@/views/container/Redirect.vue'),
          meta: { title: '隐患专项排查', redirect: true, menuChildren: true },
          children: [
            {
              name: 'hd-special-check-list',
              path: 'hd-special-check-list',
              component: () => import('@/views/dual-pre-control/hierarchical-control/hazar-investigation/hd-special-check/List.vue'),
              meta: { title: '' }
            },
            {
              name: 'hd-special-check-create',
              path: 'hd-special-check-create',
              component: () => import('@/views/dual-pre-control/hierarchical-control/hazar-investigation/hd-special-check/CreateUpdate.vue'),
              meta: { title: '新增' }
            },
            {
              name: 'hd-special-check-update',
              path: 'hd-special-check-update',
              component: () => import('@/views/dual-pre-control/hierarchical-control/hazar-investigation/hd-special-check/CreateUpdate.vue'),
              meta: { title: '编辑' }
            },
            {
              name: 'hd-special-check-detail',
              path: 'hd-special-check-detail',
              component: () => import('@/views/dual-pre-control/hierarchical-control/hazar-investigation/hd-special-check/Detail.vue'),
              meta: { title: '详情' }
            }
          ]
        },
        {
          name: 'hd-handle',
          path: 'hd-handle',
          component: () => import('@/views/container/Redirect.vue'),
          meta: { title: '隐患处置', redirect: true, menuChildren: true },
          children: [
            {
              name: 'hd-handle-list2',
              path: 'hd-handle-list2',
              component: () => import('@/views/dual-pre-control/hierarchical-control/hazar-investigation/hd-handle/HdHandle.vue'),
              meta: { title: '列表' }
            },
            {
              name: 'hd-handle-blame',
              path: 'hd-handle-blame',
              component: () => import('@/views/dual-pre-control/hierarchical-control/hazar-investigation/hd-handle/Blame.vue'),
              meta: { title: '安全检查通报' }
            }
          ]
        },
        {
          name: 'hd-record',
          path: 'hd-record',
          component: () => import('@/views/container/Redirect.vue'),
          meta: { title: '隐患台账', redirect: true, menuChildren: true },
          children: [
            {
              name: 'hd-handle-list',
              path: 'hd-handle-list',
              component: () => import('@/views/dual-pre-control/hierarchical-control/hazar-investigation/hd-record/List.vue'),
              meta: { title: '隐患台账列表' }
            },
            {
              name: 'hd-handle-detail',
              path: 'hd-handle-detail',
              component: () => import('@/views/dual-pre-control/hierarchical-control/hazar-investigation/hd-record/Detail.vue'),
              meta: { title: '隐患台账详情' }
            }
          ]
        }
      ]
    },
    {
      name: 'risk-four-map',
      path: 'risk-four-map',
      component: () => import(
        '@/views/dual-pre-control/risk-four-map/RiskMap.vue'),
      meta: {
        title: '风险四色图'
      }
    },
    {
      name: 'comprehensive-investigation',
      path: 'comprehensive-investigation',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '综合排查',
        redirect: true,
        icon: 'icon-shezhi'
      },
      children: [{
        name: 'checklist-template',
        path: 'checklist-template',
        component: () => import('@/views/container/Redirect.vue'),
        meta: {
          title: '检查表模板', redirect: true
        },
        children: [
          {
            name: 'checklist-template-list',
            path: '',
            component: () => import(
              '@/views/dual-pre-control/comprehensive-investigation/checklist-template/ChecklistTemplate.vue'),
            meta: { title: '检查表模板列表' }
          },
          {
            name: 'checklist-template-form',
            path: 'form',
            component: () => import(
              '@/views/dual-pre-control/comprehensive-investigation/checklist-template/ChecklistTemplateForm.vue'),
            meta: { title: '检查表模板表单', noLimits: true, hideBreadcrumb: true }
          },
          {
            name: 'checklist-template-details',
            path: 'details',
            component: () => import(
              '@/views/dual-pre-control/comprehensive-investigation/checklist-template/ChecklistTemplateDetails.vue'),
            meta: { title: '检查表模板详情', noLimits: true, hideBreadcrumb: true }
          }
        ]
      },
      {
        name: 'inspection-plan-manage',
        path: 'inspection-plan-manage',
        component: () => import('@/views/container/Redirect.vue'),
        meta: { title: '排查计划管理', redirect: true, menuChildren: true },
        children: [
          {
            name: 'inspection-plan-list',
            path: 'inspection-plan-list',
            component: () => import(
              '@/views/dual-pre-control/comprehensive-investigation/inspection-plan-manage/InspectionPlanManage.vue'),
            meta: { title: '排查计划列表' }
          },
          {
            name: 'inspection-plan-form',
            path: 'inspection-plan-form',
            component: () => import(
              '@/views/dual-pre-control/comprehensive-investigation/inspection-plan-manage/InspectionPlanForm.vue'),
            meta: { title: '新增排查计划' }
          },
          {
            name: 'inspection-plan-detail',
            path: 'inspection-plan-detail',
            component: () => import(
              '@/views/dual-pre-control/comprehensive-investigation/inspection-plan-manage/InspectionPlanDetail.vue'),
            meta: { title: '排查计划详情' }
          }
        ]
      },
      {
        name: 'inspection-basis-base',
        path: 'inspection-basis-base',
        component: () => import(
          '@/views/dual-pre-control/comprehensive-investigation/inspection-basis-base/InspectionBasisBase.vue'),
        meta: {
          title: '检查依据库'
        }
      }]
    },
    {
      name: 'config-manger',
      path: 'config-manger',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '配置管理',
        redirect: true,
        icon: 'icon-shezhi'
      },
      children: [{
        name: 'risk-remark-method',
        path: 'risk-remark-method',
        component: () => import(
          '@/views/dual-pre-control/hierarchical-control/config-manger/risk-remark-method/index.vue'),
        meta: {
          title: '风险辨识评价方法'
        }
      },
      {
        name: 'hazar-investiger-manger',
        path: 'hazar-investiger-manger',
        component: () => import(
          '@/views/dual-pre-control/hierarchical-control/config-manger/hazar-investiger-manger-config/ParameterSetting.vue'),
        meta: {
          title: '参数设置'
        }
      }]
    }
  ]

}
